<template>
  <div class="inline-block">
    <span @click="handleOpen">
      <slot></slot>
    </span>
    <el-dialog :title="title" :visible.sync="dialogVisible" :width="width" @close="close">
      <sirui-search
        v-if="searchColumns.length"
        ref="siruiSearch"
        :query="query"
        :columns="searchColumns"
        :colSpan="colSpan"
        :buttonSpan="buttonSpan"
        @resetBtnClick="resetBtnClick"
        @searchBtnClick="search"
      ></sirui-search>
      <div class="main-content">
        <sirui-table
          :rowKey="propCode || 'id'"
          ref="siruiTable"
          :loading="load"
          :data="tableData"
          :paging="page"
          :checkRowKeys="curCheckedKeys"
          :checkMethod="checkMethod"
          @sortChangeEvent="sortChangeEvent"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handlePagination"
          @handleSelectionChange="handleSelectionChange"
          @dblclickEvent="dblclickEvent"
        >
          <vxe-table-column
            v-if="isMultiple"
            type="checkbox"
            width="50"
            fixed="left"
          ></vxe-table-column>
          <vxe-table-column v-else type="radio" width="50" fixed="left"></vxe-table-column>
          <vxe-table-column
            v-for="(item, index) in columnList"
            :key="index"
            :type="item.type"
            :fixed="item.fixed"
            :field="item.prop"
            :title="item.label"
            :width="item.width || columnWidth"
            :sortable="item.sortable"
          >
            <template slot-scope="scope">
              <span v-if="typeof item.render == 'function'">{{
                item.render(scope.row[item.prop], scope.row)
              }}</span>
              <span v-else>{{ scope.row[item.prop] }}</span>
            </template>
          </vxe-table-column>
        </sirui-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">{{ $t('dialog.cancel') }}</el-button>
        <el-button type="primary" @click="handleConfirm">{{ $t('dialog.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import { filterEmpty, toLine } from '@/common/js/util';
  export default {
    props: {
      title: {
        // 弹窗标题
        type: String,
        default: () => '',
      },
      width: {
        // 弹窗宽度
        type: String,
        default: () => '800px',
      },
      //搜索区域的内容
      searchColumns: {
        type: Array,
        default: () => [],
      },
      // 查询的接口
      API: {
        type: String,
        default: () => '',
      },
      page: {
        type: Boolean,
        default: () => true,
      },
      // 表格展示的内容
      columnList: {
        type: Array,
        default: () => [],
      },
      // 是否多选
      isMultiple: {
        type: Boolean,
        default: () => true,
      },
      // 外部控制弹窗是否显示
      defaultVisible: {
        type: Boolean,
        default: () => false,
      },
      // 设置默认选中
      checkRowKeys: {
        type: Array,
        default: () => [],
      },
      // 表格列默认宽度
      columnWidth: {
        type: Number,
        default: undefined,
      },
      // 选中字段的key
      propCode: {
        type: String,
        default: 'id',
      },
      // 搜索默认分隔的colSpan，分成三列
      colSpan: {
        type: Number,
        default: 8,
      },
      // 右边按钮占位，弹窗占位需要宽一点
      buttonSpan: {
        type: Number,
        default: 4,
      },
      // 确认后是否选中，默认再次打开之前的还是选中的
      confirmUnchecked: {
        type: Boolean,
        default: true,
      },
    },
    components: {
      SiruiSearch,
      SiruiTable,
    },
    data() {
      return {
        dialogVisible: false,
        load: false,
        tableData: [],
        query: {},
        multipleSelection: [],
        curCheckedKeys: this.checkRowKeys,
        extraData: {},
      };
    },
    watch: {
      defaultVisible() {
        if (this.defaultVisible) {
          this.handleOpen();
        }
        this.dialogVisible = this.defaultVisible;
      },
      checkRowKeys(newValue) {
        this.curCheckedKeys = newValue;
      },
    },
    methods: {
      handleOpen(extraData) {
        this.initQuery();
        this.extraData = extraData;
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.getData();
        });
      },
      // 已完结的不允许删除
      checkMethod({ row }) {
        if (row.settleStatus === 'PCZT02') {
          return false;
        }
        return true;
      },
      // 初始化查询参数
      initQuery() {
        const query = {};
        this.searchColumns.forEach((item) => {
          if (item.prop) {
            if (typeof item.prop === 'string') {
              query[item.prop] = undefined;
            } else {
              item.prop.forEach((prop) => {
                query[prop] = undefined;
              });
            }
          }
        });
        this.query = Object.assign({}, query);
      },
      close() {
        this.dialogVisible = false;
        this.$emit('close');
      },
      handleConfirm() {
        const curSelect = this.isMultiple
          ? this.$refs.siruiTable.getCheckboxRecords()
          : [this.$refs.siruiTable.getRadioRecord()];
        const prevSelectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        const selectedList = curSelect.concat(prevSelectedList); // 选中数据
        // 点击后注入选中keys，再次打开保留选中，如果不需要则不操作
        if (this.confirmUnchecked) {
          this.curCheckedKeys = selectedList.map((item) => {
            return item[this.propCode];
          });
        }
        this.$emit('confirm', selectedList);
      },
      getData(search) {
        if (!this.API) return;
        const query = this.getQuery();
        if (search && Object.keys(query).length == 2) {
          this.$message({
            showClose: true,
            message: this.$t('search.nosearchError'),
            type: 'error',
          });
          return;
        }
        const params = Object.assign({}, this.extraData, query);
        this.load = true;
        this.$axios
          .post(this.API, params)
          .then((res) => {
            this.load = false;
            if (0 == res.data.code) {
              if (this.page) {
                this.tableData = res.data.data.list;
                this.$refs.siruiTable.reloadTable(res.data.data.list);
                this.$refs.siruiTable.setPageTotal(res.data.data.total);
              } else {
                this.tableData = res.data.data;
              }
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          })
          .catch(() => {
            this.load = false;
          });
      },
      // 获取查询参数
      getQuery() {
        // 分页数据
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const query = this.query;
        const result = Object.assign({}, query, {
          pageNum,
          pageSize,
        });
        this.searchColumns.forEach((item) => {
          if (item.getSearchCode) {
            const arr = query[item.prop];
            if (arr && arr.length) {
              const codes = arr.map((code) => {
                return code[item.getSearchCode];
              });
              // 单选改第一个，多选给多个
              result[item.prop] = item.isMultiple ? codes[0] : codes;
            }
          }
        });
        return filterEmpty(result);
      },
      // 表格排序
      sortChangeEvent({ property, order }) {
        let orderByDesc = '';
        if (order) {
          orderByDesc = `${toLine(property)} ${order}`;
        }
        const query = Object.assign({}, this.query, {
          orderByDesc,
        });
        this.query = query;
        this.getData();
      },
      // 点击分页
      handlePagination() {
        this.getData();
      },
      // 分页条数改变
      handleSizeChange() {
        this.getData();
      },
      // 搜索
      search() {
        this.$refs.siruiTable.setPageNum(1);
        this.getData(true);
      },
      //双击单元格事件
      dblclickEvent(val) {
        this.$emit('dblclickEvent', val);
      },
      // 表格选中行
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
      // 重置
      resetBtnClick() {
        this.$refs.siruiTable.clearCheckboxReserve();
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.getData();
      },
    },
  };
</script>
